import { Navigate } from 'react-router-dom';

// La vecchia schermata "Verifica" (2 caselle di conferma) è stata FUSA nella
// schermata /mnemonic per accorciare l'onboarding di un passaggio. Questa route
// resta solo come redirect di sicurezza (vecchi link / back).
export default function VerifyScreen() {
  return <Navigate to="/mnemonic" replace />;
}
